import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import StandardPageLayout from '@layouts/standardPageLayout'
import RouteLoading from '@shared/routing/RouteLoading'
import { T } from '@transifex/react'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

const SpacesRoute = lazyWithRetries(() => import('.'))
const ConfigureSpacesRoute = lazyWithRetries(() => import('./configureSpace'))

const routes: RouteObject[] = [
  {
    path: AppPaths.tenant.spaces(),
    element: (
      <StandardPageLayout elementId="spacesRoute" maxWidth={1080} title={<T _str="Spaces" />}>
        <Suspense fallback={<RouteLoading />}>
          <SpacesRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.configureSpace(':spaceId?'),
    element: (
      <StandardPageLayout elementId="configureSpaceRoute" maxWidth={1080}>
        <Suspense fallback={<RouteLoading />}>
          <ConfigureSpacesRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
]

export default routes
